export default __webpack_public_path__ + "static/media/tab1.a4e47813.svg";